import React, { useCallback, useEffect, useState } from "react";
import { Toolbar, Typography, Box, Button } from "@mui/material";
import TableRowsLoader from "../../../components/common/Loader/tableLoader";
import { ACHType } from "../../../types/genericType";
import { getACHDetails } from "../../../services/batchService";
import PrintIcon from "@mui/icons-material/Print";
import ACHTable from "../../../components/achTable/ACHTable";
import { GridRowSelectionModel } from "@mui/x-data-grid";
import useFileDownloader from "../../../hooks/useFileDownloader";
import { apiEndPoints } from "../../../variables/apiEndpoints";
import CustomSnackbar from "../../../components/common/Snackbar/CustomSnackbar";

const BatchACH = () => {
  const [search, setSearch] = useState("");
  const [rowSelectionModel, setRowSelectionModel] =
    useState<GridRowSelectionModel>([]);
  const [onSuccess, setOnSuccess] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [achDetails, setACHDetails] = useState<ACHType[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { downloadFile } = useFileDownloader();

  const initialLoad = () => {
    setIsLoading(true);
    getACHDetails().then((res) => {
      setIsLoading(false);
      setACHDetails(res);
    });
  };

  useEffect(() => {
    initialLoad();
  }, []);

  const handleSearchChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    setSearch(event.target.value);
  };

  const clearSearch = () => {
    setSearch("");
  };

  const filteredACH = achDetails.filter((ach: any) => {
    return ach.details.toLowerCase().includes(search.toLowerCase());
  });

  const handleDownload = useCallback(async () => {
    const result = await downloadFile({
      url: `/reports/${apiEndPoints.ach}`,
      method: "post",
      fileName: "AchRecords.csv",
      data: rowSelectionModel,
    });
    if (result.success) {
      setRowSelectionModel([]);
      initialLoad();
    } else {
      setSnackbarMsg(result.errorMessage || "Error downloading file");
      setOnSuccess(true);
    }
  }, [downloadFile]);

  const handlePrintACH = () => {
    rowSelectionModel.length > 0 && handleDownload();
  };

  return (
    <>
      <Toolbar
        sx={{
          justifyContent: "space-between",
          margin: "0px 15px",
        }}
      >
        <Typography className="transactions-history-title">
          Batch ACH
        </Typography>
        <Button
          variant="contained"
          color="primary"
          className="new-btn"
          component="button"
          onClick={() => {
            handlePrintACH();
          }}
        >
          {<PrintIcon sx={{ marginRight: "10px" }} />} PRINT
        </Button>
      </Toolbar>
      <Box sx={{ margin: "20px 40px" }}>
        {isLoading ? (
          <TableRowsLoader rowsNum={10} />
        ) : achDetails.length > 0 ? (
          <ACHTable
            data={filteredACH}
            search={search}
            onSearchChange={handleSearchChange}
            clearSearch={clearSearch}
            rowSelectionModel={rowSelectionModel}
            setRowSelectionModel={setRowSelectionModel}
          />
        ) : (
          <Typography>No ACH records found</Typography>
        )}
      </Box>
      <CustomSnackbar
        open={onSuccess}
        message={snackbarMsg}
        setOpen={setOnSuccess}
      />
    </>
  );
};

export default BatchACH;
